import {IAllUserNode} from '../../../types/users'
import {PhoneProviderActions} from '../../../components/telephony/PhoneProviderActions'

interface IOverviewTabProps {
  node: IAllUserNode
  refetch: () => void
  setTabs: (TTabsOneUser) => void
}
export const OverviewTab: React.FC<IOverviewTabProps> = ({node, refetch, setTabs}) => {
  // export const OverviewTab = ({node}: {node: IAllUserNode}) => {
  const organizationName = node.organization?.name
  const organizationWebsite = node.organization?.website
  const organizationCountry = node.organization?.country

  return (
    <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
      <div className='card-header cursor-pointer'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Profile Details</h3>
        </div>
        <button className='btn btn-primary align-self-center' onClick={() => setTabs('Edit user')}>
          Edit Profile
        </button>
        {/* <button className='btn btn-primary align-self-center'>Edit Profile</button> */}
      </div>

      <div className='card-body p-9'>
        <div className='row mb-7'>
          <label className='col-lg-4 fw-bold text-muted'>Full Name</label>

          <div className='col-lg-8'>
            <span className='fw-bolder fs-6 text-dark'>
              {node.firstName} {node.lastName}
            </span>
          </div>
        </div>

        <div className='row mb-7'>
          <label className='col-lg-4 fw-bold text-muted'>NPN</label>

          <div className='col-lg-8'>
            <span className='fw-bolder fs-6 text-dark'>
              {node.npn}
            </span>
          </div>
        </div>

        <div className='row mb-7'>
          <label className='col-lg-4 fw-bold text-muted'>Company</label>

          <div className='col-lg-8 fv-row'>
            <span className='fw-bold fs-6'>
              {organizationName || 'N/R'}
            </span>
          </div>
        </div>

        <div className='row mb-7'>
          <label className='col-lg-4 fw-bold text-muted'>
            Contact Phone
            <i
              className='fas fa-exclamation-circle ms-1 fs-7'
              data-bs-toggle='tooltip'
              title='Phone number must be active'
            ></i>
          </label>

          <div className='col-lg-8 d-flex align-items-center gap-2 flex-wrap'>
            <PhoneProviderActions
              phone={node.cellphone}
              textClassName='fw-bolder fs-6 me-2'
            />

            {node.cellphone && <span className='badge badge-success'>Verified</span>}
          </div>
        </div>

        <div className='row mb-7'>
          <label className='col-lg-4 fw-bold text-muted'>Company Site</label>

          <div className='col-lg-8'>
            {organizationWebsite ? (
              <a
                href={organizationWebsite}
                target='_blank'
                rel='noopener noreferrer'
                className='fw-bold fs-6 text-info text-hover-primary text-hover-underline'
              >
                {organizationWebsite.replace(/^https?:\/\//, '')}
              </a>
            ) : (
              <span className='fw-bold fs-6 text-muted'>N/R</span>
            )}
          </div>
        </div>

        <div className='row mb-7'>
          <label className='col-lg-4 fw-bold text-muted'>
            Country
            <i
              className='fas fa-exclamation-circle ms-1 fs-7'
              data-bs-toggle='tooltip'
              title='Country of origination'
            ></i>
          </label>

          <div className='col-lg-8'>
            <span className='fw-bolder fs-6 text-dark'>{organizationCountry || 'N/R'}</span>
          </div>
        </div>

        <div className='row mb-7'>
          <label className='col-lg-4 fw-bold text-muted'>Communication</label>

          <div className='col-lg-8'>
            <span className='fw-bolder fs-6 text-dark'>{node.email || 'N/R'}</span>
          </div>
        </div>

        {/* <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed p-6'>
          <KTIcon iconName='information-5' className='fs-2tx text-warning me-4' />
          <div className='d-flex flex-stack flex-grow-1'>
            <div className='fw-bold'>
              <h4 className='text-gray-800 fw-bolder'>We need your attention!</h4>
              <div className='fs-6 text-gray-600 d-flex align-items-center gap-2'>
                Your payment was declined. To start using tools, please
                <button className='fw-bolder btn btn-link'> Add Payment Method</button>.
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  )
}
